import React from 'react';
import moment from 'moment';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    SelectInput,
} from 'react-admin';
import ErrorBoundary from '../ErrorBoundary';

const statOptions = [
    {
        id: 'A',
        name: 'Applicant'
    },
    {
        id : 'Q',
        name: 'Qualified'
    }
  ]

export const BleedLogsFilter = props => (
    <Filter {...props}>
        
        <DateInput source="bleed_date" alwaysOn label='Bleeding Date' locales="en-us"/>
        <SelectInput source="status" label='Donor Status' choices={statOptions}/>
        <TextInput source="ssn" label="SSN"/>
        <TextInput source="name" label="Name"/>
        <TextInput source="case_no" label="Case #"/>
    </Filter>
);

export const BleedDate = ({ record }) => {
    
    return (
        <span>{record ? `${moment(record.bleed_date).format('MM/DD/YYYY')}` : ''}</span>
    );
};

export const Volume = ({ record }) => {
    
    return (
        <span>{record ? `${Number.parseFloat(record.volume).toPrecision(3)}` : ''}</span>
    );
};

export const BleedLogsList = props => (
    <ErrorBoundary>  
    <List 
        {...props}
        filters={<BleedLogsFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'DESC' }}
        bulkActionButtons ={false}
        >
        <Datagrid >
            <BleedDate label="Bleed Date" />
            <TextField source="ssn" label="SSN" />
            <TextField source="name" label="Donor Name" />
            <TextField source="ucn" label="Unit Control#" />
            <Volume label="Volume (L)" />
            <TextField source="case_no" label="Case #"/>
            <TextField source="status"  lael="Donor status" />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default BleedLogsList
